import { Component, Input } from '@angular/core';

@Component({
  selector: 'wave-video-block',
  templateUrl: './wave-video-block.component.html',
  styleUrls: ['./wave-video-block.component.scss']
})
export class WaveVideoBlockComponent {
@Input() video_url: string = `https://firebasestorage.googleapis.com/v0/b/qatchcode-production.appspot.com/o/videos%2Fvip_MVI_6002.MP4?alt=media&token=f299efac-764e-4858-babc-78a3e8e8afaf`

}
